import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import FundSourceForm from '../FundSourceForm';
import { GET_FUND_SOURCE } from '../queries';

function FundSourceEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_FUND_SOURCE, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error('get fund source', error);
    history.goBack();
  }

  const formatValue = { ...data.fundSource };
  if (!data.fundSource) {
    history.goBack();
  }

  return <FundSourceForm fundSource={formatValue} id={id} isEdit />;
}

FundSourceEdit.propTypes = {};

export default FundSourceEdit;
